import { useProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import ProductImage from "@/components/ProductImage";
import Reveal from "@/components/Reveal";
import Marquee from "@/components/Marquee";

export default function Collections() {
  const { products } = useProducts();
  const drop = products.filter((p) => p.is_new);
  const archive = products.filter((p) => !p.is_new);

  return (
    <div data-testid="collections-page" className="pt-24">
      <section className="relative overflow-hidden border-b border-white/10 px-5 py-20 sm:px-8">
        <span className="pointer-events-none absolute -right-4 top-0 select-none font-display text-[14rem] font-extrabold leading-none text-bone/[0.04]">001</span>
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.35em] text-fade">COLLECTIONS</p>
          <h1 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tight text-bone sm:text-7xl">
            Drop 001 —<br />
            Stay aligned
          </h1>
          <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-neutral-400">
            The first alignment. Eight pieces built heavy, washed dark, and marked with the numbers 111 through 555. Each garment carries one signal — choose the one that keeps finding you.
          </p>
        </Reveal>
      </section>

      {drop.length > 0 && (
        <section className="grid gap-px border-b border-white/10 bg-white/10 lg:grid-cols-2">
          <Reveal className="bg-ink p-6 sm:p-10">
            <ProductImage product={drop[0]} ratio="aspect-[4/5]" tag="DROP 001 — KEY PIECE" />
          </Reveal>
          <div className="flex flex-col justify-center bg-ink p-8 sm:p-14">
            <p className="font-mono text-[10px] tracking-[0.35em] text-fade">THE ANCHOR</p>
            <h2 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-bone sm:text-4xl">{drop[0].name}</h2>
            <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-neutral-400">{drop[0].meaning}</p>
            <p className="mt-6 font-mono text-[10px] tracking-[0.25em] text-fade">{drop[0].fabric}</p>
          </div>
        </section>
      )}

      <section className="px-0 py-16">
        <div className="px-5 sm:px-8">
          <Reveal>
            <h2 className="font-display text-2xl font-extrabold uppercase tracking-tight text-bone">The full drop</h2>
          </Reveal>
        </div>
        <div className="mt-10 grid grid-cols-1 border-y border-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {drop.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </section>

      <Marquee items={["DROP 001", "STAY ALIGNED", "RIGHT PLACE. RIGHT TIME."]} />

      {archive.length > 0 && (
        <section className="py-16">
          <div className="px-5 sm:px-8">
            <Reveal>
              <p className="font-mono text-[10px] tracking-[0.35em] text-fade">STILL IN ORBIT</p>
              <h2 className="mt-2 font-display text-2xl font-extrabold uppercase tracking-tight text-bone">Carry-over pieces</h2>
            </Reveal>
          </div>
          <div className="mt-10 grid grid-cols-1 border-y border-white/10 sm:grid-cols-2 lg:grid-cols-4">
            {archive.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
